<div class="content_wrap">
  <div class="container-fluid">
    <div class="breadcrumb_wrap">
      <div class="page_title">
        <h2>Payment History</h2>
      </div>
    </div>
    <div class="scrollable_area">
      <div class="action_legends">
        <ul>
          <li><i class="ri-eye-line"></i>View Receipt</li>
        </ul>
      </div>
      <div class="k-grid-toolbar">
        <div class="search-box">
          <input
            class="k-input"
            placeholder="{{ gridSearchPlaceholder }}"
            kendoTextBox
            [maxlength]="globals.gridSearchMaxLength"
            (input)="gridSearchChange()"
            [(ngModel)]="searchText"
          />
        </div>
      </div>
      <div class="res_tbl">
        <kendo-grid
          #kendoGrid
          [data]="gridData"
          [pageable]="true"
          [pageSize]="gridState.take"
          [skip]="gridState.skip"
          [sortable]="{
                  allowUnsort: false,
                  mode: 'single',
                }"
          [sort]="gridState.sort"
          (dataStateChange)="stateChange($event)"
          (sortChange)="sortChange($event)"
          scrollable="none"
        >
          <kendo-grid-column
            field="credential_name"
            title="Credential Name"
            [headerStyle]="{ width: '28%' }"
            [style]="{ width: '28%' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span
                >{{ dataItem.credentialName }}
                <span
                  class="renewal-badge"
                  *ngIf="dataItem.is_for_initial_app === 0"
                >
                  Recertification
                </span>
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="typeLabel"
            title="Type"
            [headerStyle]="{ width: '15%' }"
            [style]="{ width: '15%' }"
            [sortable]="true"
          >
          </kendo-grid-column>

          <kendo-grid-column
            field="fees"
            title="Fees"
            [headerStyle]="{ width: '10%' }"
            [style]="{ width: '10%' }"
            [sortable]="true"
            class="text-center editinput"
            [headerClass]="'headerCustomClass'"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>
                {{ dataItem.fees ? "$" + dataItem.fees : "N/A" }}
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column
            field="transaction_id"
            title="Transaction ID"
            [headerStyle]="{ width: '25%' }"
            [style]="{ width: '25%' }"
            [sortable]="true"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              <span>
                {{ dataItem.transaction_id ? dataItem.transaction_id : "N/A" }}
              </span>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="updated_at"
            title="Transaction on"
            [headerStyle]="{ width: '15%' }"
            [style]="{ width: '15%' }"
          >
            <ng-template kendoGridCellTemplate let-dataItem>
              {{
                commonService.convertUTCToLocal(dataItem.updated_at ?? "")
                  | date : "MMM d, y h:mm a"
              }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-command-column
            title="Action"
            [headerStyle]="{ width: '7%' }"
            [style]="{ width: '7%' }"
            class="text-center"
            [headerClass]="'headerCustomClass'"
          >
            <ng-template
              kendoGridCellTemplate
              let-isNew="isNew"
              let-dataItem="dataItem"
            >
              <div kendoTooltip position="top">
                <button
                  *ngIf="dataItem?.transaction_id"
                  kendoGridEditCommand
                  title="View Receipt"
                  class="icon_btn"
                  (click)="viewReceipt(dataItem.transaction_id)"
                >
                  <i class="ri-eye-line"></i>
                </button>
              </div>
            </ng-template>
          </kendo-grid-command-column>
          <ng-template kendoGridNoRecordsTemplate>
            <p>No payment history available.</p>
          </ng-template>
          <ng-template kendoPagerTemplate>
            <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons
              [buttonCount]="3"
            ></kendo-pager-numeric-buttons>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes
              [pageSizes]="globals.pageSizes"
            ></kendo-pager-page-sizes>
            <kendo-pager-info></kendo-pager-info>
          </ng-template>
          <kendo-grid-messages
            [pagerItemsPerPage]="'Payment History per page'"
            [pagerItems]="'Payment History'"
          >
          </kendo-grid-messages>
        </kendo-grid>
      </div>
    </div>
  </div>
</div>
